import styled, { css } from 'styled-components';

interface IContainerProps {
  isIOS: boolean;
}

export const Container = styled.div<Omit<IContainerProps, 'theme'>>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-direction: column;
  width: 650px;
  height: 100%;
  border-radius: 20px;

  margin-bottom: 40px;
  ${props =>
    props.isIOS &&
    css`
      height: 25vh !important;
      margin-bottom: 0px;
    `}

  img {
    position: absolute;
  }

  canvas {
    width: 100% !important;
    height: 100% !important;
    border-radius: 20px;
    > div {
      background-color: purple !important;
    }
  }

  audio {
    position: absolute;
    top: 80%;
    width: 90%;
    ${props =>
      props.isIOS &&
      css`
        top: 60%;
        z-index: 3 !important;
      `}
  }
`;
